export function doDownloadFile(file,filename,type) {
    const url = window.URL.createObjectURL(new Blob([file]));
    const link = document.createElement('a');
    link.href = url;

    link.setAttribute('download', `${filename}.${type}`);
    document.body.appendChild(link);
    link.click();
}